import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IResponseTrxData {
  responseCode: string,
  responseMessage: string,
}

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface IGetTrxData {
  trx_id: string,
  trx_date: string,
  trx_desc: string,
  trx_text: string,
  employee_nip: string,
  employee_name: string,
  job_title: string,
  amount: string,
  gnlldr: string,
  sap_shkzg: string,
  status_trx: string,
  pool_id: string,
  area_id: string,
  area_name: string,
  company_code: string,
  company_relation: string,
  vendor_code: string,
  vendor_name: string,
  bank_account: string,
  bank_account_name: string,
  bank_account_number: string,
  plan_postdate: string,
  detail_bon_merah: {
    trx_id_bm: string,
    bon_merah_type: string
  },
  trx_type: {
    trx_type: string,
    description: string
  },
  department: {
    department: string,
    department_desc: string,
    department_cost: string,
    code_type: string,
    is_active: boolean
  },
  segment: {
    code_segment: string,
    code_description: string
  },
  trx_code: {
    trx_code: string,
    trx_desc: string,
    sap_bktxt: string,
    gnlldr: string,
    sap_shkzg: string
  },
  trx_files: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[],
  trx_approvals: {
    id: number,
    trx_id: string,
    approval_code: string,
    approval_number: number,
    department: string,
    job_id: number,
    job_title: string,
    job_flow: string,
    employee_id: string,
    employee_name: string,
    employee_email: string,
    status_approval: string,
    reason_status: string,
    status_bon: string,
    approval_start: string,
    approval_end: string,
    create_at: string,
    create_by: string,
    update_at: string,
    update_by: string
  }[],
  create_at: string,
  extend_status: string,
  extend_bm: string,
  transfer_confirmation?: {
    trx_id: string,
    status: string,
    confirmation_date: string,
    bonid: string
  },
  is_approval_progress: boolean,
}

export interface IGetTrxHistoryData {
  trx_id: string,
  trx_date: string,
  trx_desc: string,
  trx_text: string,
  employee_nip: string,
  employee_name: string,
  amount: string,
  gnlldr: string,
  sap_shkzg: string,
  status_trx: string,
  pool_id: string,
  area_id: string,
  area_name: string,
  company_code: string,
  company_relation: string,
  vendor_code: string,
  vendor_name: string,
  bank_account: string,
  bank_account_name: string,
  bank_account_number: string,
  plan_postdate: string,
  trx_type: string,
  trx_type_description: string,
  department: {
    department: string,
    department_desc: string,
    department_cost: string,
    code_type: string,
    is_active: boolean
  },
  code_segment: string,
  code_description: string,
  trx_code: {
    trx_code: string,
    trx_desc: string,
    sap_bktxt: string,
    gnlldr: string,
    sap_shkzg: string
  },
  trx_files: {
    file_text: string,
    file_count: string
  },
  create_at: string,
  job_title: string,
  extend_status: string,
  extended_bm: string
}

export interface IGetTrxResponse {
  list_transaction: IGetTrxData[],
  metadata: MetadataI,
}

export interface IGetTrxHistoryResponse {
  list_trx_history: IGetTrxHistoryData[],
  metadata: MetadataI,
}

export interface GetTrxParamsI {
  page_number?: string,
  page_size?: number,
  search?: string,
  start_date?: string,
  end_date?: string,
  status_approval: "CLOSE" | "CANCEL" | "OPEN" | "CREATED",
  employee_email: string,
  sort_by?: string,
  sort_type?: string,
  pool_id?: string;
  area_id?: string;
  code_type?: string;
}

export interface GetTrxHistoryParamsI {
  page_number?: string,
  page_size?: number,
  search?: string,
  start_date?: string,
  end_date?: string,
  status_bon?: "CLOSE" | "CANCEL" | "OPEN" | "",
  department: string,
  pool_id: string,
  company_code: string,
  employee_email: string,
  sort_by?: string,
  sort_type?: string,
}

export interface IGetDetailTrxResponse {
  trx_id: string,
  trx_date: string,
  trx_desc: string,
  trx_text: string,
  employee_nip: string,
  employee_name: string,
  job_title: string,
  amount: string,
  gnlldr: string,
  sap_shkzg: string,
  status_trx: string,
  pool_id: string,
  area_id: string,
  area_name: string,
  company_code: string,
  company_relation: string,
  vendor_code: string,
  vendor_name: string,
  bank_account: string,
  bank_account_name: string,
  bank_account_number: string,
  plan_postdate: string,
  detail_bon_merah: {
    trx_id_bm: string,
    bon_merah_type: string
  },
  trx_type: {
    trx_type: string,
    description: string
  },
  department: {
    department: string,
    department_desc: string,
    department_cost: string,
    code_type: string,
    is_active: boolean
  },
  segment: {
    code_segment: string,
    code_description: string
  },
  trx_code: {
    trx_code: string,
    trx_desc: string,
    sap_bktxt: string,
    gnlldr: string,
    sap_shkzg: string
  },
  trx_files: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[],
  trx_approvals: {
    id: number,
    trx_id: string,
    approval_code: string,
    approval_number: number,
    department: string,
    job_id: number,
    job_title: string,
    job_flow: string,
    employee_id: string,
    employee_name: string,
    employee_email: string,
    status_approval: string,
    reason_status: string,
    status_bon: string,
    approval_start: string,
    approval_end: string,
    create_at: string,
    create_by: string,
    update_at: string,
    update_by: string
  }[],
  create_at: string,
  extend_status: string,
  extend_bm: string,
  transfer_confirmation: {
    trx_id?: string,
    status?: string,
    confirmation_date?: string,
    bonid?: string
  }
}

interface IPostTrxPayload {
  trx_type: string,
  code_type: string,
  area_id: string,
  pool_id: string,
  company_code: string,
  company_relations: string,
  code_segment: string,
  department: string,
  trx_date: string,
  plan_postdate: string,
  trx_code: string,
  trx_text: string,
  amount: string,
  prctr: string,
  kostl: string,
  kunnr: string,
  lifnr: string,
  approval_code: string,
  idtrx1: string,
  idtrx2: string,
  idtrx3: string,
  beneficiary_code: string,
  source_code: string,
  employee_id: string,
  employee_name: string,
  employee_email: string,
  job_id: number,
  job_title: string,
  item_bon_merah: {
    trx_bm_type: string
  },
  item_bon_putih_ijir: {
    trx_id_bon_merah: string
  },
  create_by: string,
  lsttrxfile: {
    item_id: number,
    file_name: string,
    file_base64: string,
    file_size: string,
    create_by: string
  }[]
}

export interface GetUserPoolDepartmentParamsI {
  job_title: string,
  department: string,
  code_type: string,
  user_email: string
}

export interface PoolItemI {
  pool_id: string,
  code_type: string,
  pool_name: string,
  area_id: string
}

export interface DepartmentItemI {
  department: string,
  department_desc: string,
  code_type: string
}
export interface IGetUserPoolDepartmentResponse extends GetUserPoolDepartmentParamsI {
  list_pool: PoolItemI[],
  list_department: DepartmentItemI[]
}

export const url = "/v1/smpltrx";

export const postTrx = async (
  payload: IPostTrxPayload,
): Promise<IResponseTrxData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const getTrx = async (
  payload: GetTrxParamsI,
): Promise<IGetTrxResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}${payload.status_approval === "CREATED" ? "" : "/request-approval"}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getDetailTrx = async (
  id: string,
  extendBm?: string,
): Promise<IGetDetailTrxResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}/${extendBm || "0"}`,
    method: "GET",
  });

  return data;
};

export const deleteTrx = async (
  id: string | number,
): Promise<IResponseTrxData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "DELETE",
  });

  return data;
};

export const getTrxHistory = async (
  payload: GetTrxHistoryParamsI,
): Promise<IGetTrxHistoryResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}history`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getUserPoolDepartment = async (
  payload: GetUserPoolDepartmentParamsI,
): Promise<IGetUserPoolDepartmentResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}history/filter-user`,
    method: "POST",
    data: payload,
  });

  return data;
};
